import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { TchekTablesService } from "@app/tcheck/tchek-tables.service";
import { TcheckService } from "../../tcheck/tcheck.service";
import { SettlementsService } from "../shared/settlements.service";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-company-expenses",
  templateUrl: "./companyExpenses.component.html",
  styleUrls: ["./companyExpenses.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyExpensesComponent implements OnInit {
  errorMsg: any;
  records = [];
  startDate: Date;
  endDate: Date;
  loading = false;
  loadingRecords = false;
  batchesList: any[] = [];
  selectedBatch: any;

  constructor(
    private tcheckService: TcheckService,
    private tchekTables: TchekTablesService,
    private toastr: ToastrService,
    private settlementsService: SettlementsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loading = true;
    this.settlementsService.getGlobalBatchListDropDown("Active").subscribe(
      (batchList: any) => {
        this.loading = false;
        this.batchesList = batchList;

        if (this.batchesList.length > 0) {
          this.selectedBatch = this.batchesList[0];
          this.refreshRecords();
        }

        this.cdr.markForCheck();
      },
      (resError) => {
        this.toastr.error(resError.message, "Error");
      }
    );
  }

  excelGeneration() {
    const cols = this.tchekTables.companyExpensesCols;
    this.tchekTables.exportToCSV(this.records, cols, "companyExpenses");
  }

  refreshRecords() {
    this.loadingRecords = true;
    this.tcheckService.getCompanyExpenses(this.selectedBatch.id).subscribe(
      (res: any) => {
        this.records = res;
        if (this.records.length > 0) {
          this.startDate = new Date(
            Math.min.apply(
              null,
              this.records.map((r) => new Date(r.date))
            )
          );
          this.endDate = new Date(
            Math.max.apply(
              null,
              this.records.map((r) => new Date(r.date))
            )
          );
        }

        this.cdr.markForCheck();
      },
      (responseTripListError) => (this.errorMsg = responseTripListError),
      () => (this.loadingRecords = false)
    );
  }
}
